import { Injectable } from '@angular/core';
import { META_KEY as ENTITY_META_KEY, DataModelInfo } from '../utils/decorators/data-model';
import * as LRU from 'lru-cache';
import 'reflect-metadata'

// Deprecated
@Injectable()
export class EntityService {
    cache: LRU;

    constructor(
    ) {
        this.cache = new LRU({
            maxAge: 60 * 60 * 1000,
            dispose: (key, value) => {
                console.log(`Dispose cache ${key}`)
            },
            noDisposeOnSet: true
        })
    }

    getFromCache(cacheKey: string): any {
        return this.cache.get(cacheKey);
    }

    mergeEntity(entity: any): any {
        if (Array.isArray(entity)) {
            return entity.map(child => this.mergeEntity(child));
        }

        const cached = null;

        if (entity) {
            const modelInfo = Reflect.getMetadata(ENTITY_META_KEY, entity.constructor) as DataModelInfo;

            if (modelInfo) {
                // const cacheKey = `${modelInfo.entityName}_${entity.id}`;
                // cached = this.getFromCache(cacheKey);

                if (!cached) {
                    // TODO
                    // this.cache.set(cacheKey, entity);
                }
            }

            Object.keys(entity).forEach(propertyName => {
                const value = entity[propertyName];
                if (value !== undefined) {
                    if (value !== null && typeof value === 'object') {
                        (cached || entity)[propertyName] = this.mergeEntity(value);
                    }
                    else if (cached) {
                        cached[propertyName] = value;
                    }
                }
            });
        }

        return cached || entity;
    }
}